import { useTranslation } from 'react-i18next';
import FullPageContentCard from 'shared/components/layout/FullPageContentCard';
import StatusScreen from 'shared/components/StatusScreen/StatusScreen';
import { useGoBackToOpportunities } from 'shared/hooks';

export default function OfferNotActualAnymore() {
    const { t } = useTranslation('candidateOffers');
    const goBack = useGoBackToOpportunities();
    
    return (
        <FullPageContentCard verticallyCenter="mobileOnly">
            <StatusScreen title={ t('confirmationPage.offerNotActualAnymore.title') }
                description={ t('confirmationPage.offerNotActualAnymore.description') }
                variant="error"
                buttonProps={ goBack ? { 
                    onClick: goBack,
                    label: t('goBackToOpportunities'),
                    color: 'secondary'
                } : undefined }
            />
        </FullPageContentCard>
    );
}
